export default {
  login: {
    title: '卖家中心登陆',
    botton: '登录',
    username: '用户名',
    password: '密码',
  },
  test: {
    lang: '中文'
  },
  base: {
    excel_upload: '导入Excel',
    excel_view_btn: '点击查看',
    start_date: '开始日期',
    end_date: '结束日期',
  }
  
}
